module.exports = __webpack_public_path__ + "img/add_expense_dollar_3.841ec41b.svg";